__turbopack_context__.v({
  "cardList": "MTwHPq_cardList",
  "colorId": "MTwHPq_colorId",
  "container": "MTwHPq_container",
  "extraRequirement": "MTwHPq_extraRequirement",
  "featureList": "MTwHPq_featureList",
  "link": "MTwHPq_link",
  "logo": "MTwHPq_logo",
  "produces": "MTwHPq_produces",
});
